import { API_URL, CUSTOMERS_KEY } from "../keys"
import axios from "axios"

export const fetchOrdersByCustomer = async (customerId: string, token: string) => {
    const response = await axios.get(`${API_URL}/orders/customer/${customerId}`, {
        headers: {
            "sce-api-key": CUSTOMERS_KEY,
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
        ,
        validateStatus: (status: number) => status < 500,
    })
    if (response) return response
}


export const createOrder = async (order: any, token : string) => {
    const response = await axios.post(`${API_URL}/orders`, order, {
        headers: {
            "sce-api-key": CUSTOMERS_KEY,
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        validateStatus: (status: number) => status < 500,
    })
    if (response) return response
}